import { Link, Text } from '@change/ds-core-ui/next';

import { useTracking } from '../../../hooks/useTracking';

export type NameProps = {
	publiclyVisible: boolean;
	slug: string | null;
	id: string;
	displayName: string;
	size?: 'small' | 'x-small';
};

export const Name: React.FC<NameProps> = ({ displayName, id, publiclyVisible, slug, size = 'small' }) => {
	const { trackDMProfileClick } = useTracking();
	return (
		<>
			{publiclyVisible ? (
				<Link
					variant="secondary"
					bold
					data-qa="dm-link"
					href={`/decision-makers/${slug || id}?source_location=petition_details_gamma_legislative_bodies`}
					onClick={() => trackDMProfileClick(id)}
				>
					<Text variant="heading" size={size}>
						{displayName}
					</Text>
				</Link>
			) : (
				<Text variant="heading" size={size}>
					{displayName}
				</Text>
			)}
		</>
	);
};
